import React from 'react';
import { useTranslation } from 'react-i18next';
import { StatBlock, Watermark } from '../ui';
import { NUMBERS } from '../../data/home';

export default function Numbers() {
  const { t } = useTranslation();
  return (
    <div className="numbers card">
      <Watermark variant="temple" />
      <span className="eyebrow">{t('Ayodhya in Numbers')}</span>
      <div className="numbers__grid">
        {NUMBERS.map((n) => <StatBlock key={n.label} value={n.value} label={t(n.label)} />)}
      </div>
    </div>
  );
}
